import { useState } from 'react';

import DefaultSwissCenterView from '../components/SwissMedicalCenterPage/DefaultSwissCenterView';
import SwissMedicalBarrioNorte from '../components/SwissMedicalCenterPage/SwissMedicalBarrioNorte';
import SwissMedicalMicroCentroMayo from '../components/SwissMedicalCenterPage/SwissMedicalMicroCentroMayo';
import SwissMedicalSarmiento from '../components/SwissMedicalCenterPage/SwissMedicalSarmiento';
import SwissMedicalBarrioParque from '../components/SwissMedicalCenterPage/SwissMedicalBarrioParque';
import SwissMedicalArcos from '../components/SwissMedicalCenterPage/SwissMedicalArcos';
import SwissMedicalBerazategui from '../components/SwissMedicalCenterPage/SwissMedicalBerazategui';
import SwissMedicalCampana from '../components/SwissMedicalCenterPage/SwissMedicalCampana';
import SwissMedicalNeuquen from '../components/SwissMedicalCenterPage/SwissMedicalNeuquen';
import SwissMedicalOlivos from '../components/SwissMedicalCenterPage/SwissMedicalOlivos';
import SwissMedicalAlmagro from '../components/SwissMedicalCenterPage/SwissMedicalAlmagro';
import SwissMedicalZamora from '../components/SwissMedicalCenterPage/SwissMedicalZamora';
import SwissMedicalRecoleta from '../components/SwissMedicalCenterPage/SwissMedicalRecoleta';

export const useMedicalCenter = () => {
  const [key, setKey] = useState('default');

  const links = [
    { key: 'default', label: '' },
    { key: 'barrio_norte', label: 'Swiss Medical Center Barrio Norte' },
    { key: 'mayo_25', label: 'Swiss Medical Center Microcentro sede 25 de Mayo' },
    { key: 'sarmiento', label: 'Swiss Medical Center Microcentro sede Sarmiento' },
    { key: 'barrio_parque', label: 'Swiss Medical Center Barrio Parque' },
    { key: 'recoleta', label: 'Swiss Medical Center Recoleta' },
    { key: 'olivos', label: 'Swiss Medical Center Olivos' },
    { key: 'neuquen', label: 'Swiss Medical Center Neuquén' },
    { key: 'almagro', label: 'Swiss Medical Center Almagro' },
    { key: 'berazategui', label: 'Swiss Medical Center Berazategui' },
    { key: 'campana', label: 'Swiss Medical Center Campana' },
    { key: 'zamora', label: 'Swiss Medical Center Lomas de Zamora' },
    { key: 'arcos', label: 'Swiss Medical Center de los Arcos' },
  ];

  const components = [
    { eventKey: 'default', comp: <DefaultSwissCenterView /> },
    { eventKey: 'barrio_norte', comp: <SwissMedicalBarrioNorte /> },
    { eventKey: 'mayo_25', comp: <SwissMedicalMicroCentroMayo /> },
    { eventKey: 'sarmiento', comp: <SwissMedicalSarmiento /> },
    { eventKey: 'barrio_parque', comp: <SwissMedicalBarrioParque /> },
    { eventKey: 'recoleta', comp: <SwissMedicalRecoleta /> },
    { eventKey: 'olivos', comp: <SwissMedicalOlivos /> },
    { eventKey: 'neuquen', comp: <SwissMedicalNeuquen /> },
    { eventKey: 'almagro', comp: <SwissMedicalAlmagro /> },
    { eventKey: 'berazategui', comp: <SwissMedicalBerazategui /> },
    { eventKey: 'campana', comp: <SwissMedicalCampana /> },
    { eventKey: 'zamora', comp: <SwissMedicalZamora /> },
    { eventKey: 'arcos', comp: <SwissMedicalArcos /> },
  ];

  return { links, components, key, setKey };
};
